import { useId } from 'react'
import styles from './DecisionPatterns.module.css'

// ChangeSet lists what a decision changes: each item's current and proposed
// value and its impact. An item marked incomplete is a proposal still missing
// a required part; its proposed value is not shown as a valid change.
export function ChangeSet({
  items = [],
  title = 'Changes after approval',
  description,
  className = '',
}) {
  const titleId = useId()

  if (!items.length) return null

  return (
    <section className={`${styles.section} ${className}`.trim()} aria-labelledby={titleId}>
      <div className={styles.sectionHeading}>
        <h3 id={titleId} className={styles.sectionTitle}>{title}</h3>
        {description ? <p className={styles.sectionDescription}>{description}</p> : null}
      </div>

      <div className={styles.changeTable}>
        <div className={styles.changeHeader} aria-hidden="true">
          <span>Field</span>
          <span>Current</span>
          <span>Proposed</span>
          <span>Impact</span>
        </div>
        <dl className={styles.changeList}>
          {items.map((item) => (
            <div key={item.key || item.label} className={styles.changeRow}>
              <dt>{item.label}</dt>
              <dd className={styles.currentValue}>
                <span className={styles.mobileLabel}>Current</span>
                <span>{item.current}</span>
              </dd>
              <dd
                className={item.incomplete ? `${styles.proposedValue} ${styles.proposedIncomplete}` : styles.proposedValue}
                data-incomplete={item.incomplete ? 'true' : undefined}
              >
                <span className={styles.mobileLabel}>Proposed</span>
                <span>{item.proposed}</span>
              </dd>
              <dd>
                <span className={styles.mobileLabel}>Impact</span>
                <span>{item.impact}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}
